import { createReducer, on } from '@ngrx/store';
import {
  loadInvestmentObjectivesFailure,
  loadInvestmentObjectivesSuccess,
  toggleInvestmentObjectivesLoading,
} from './investment-objectives.actions';
import { IInvestmentObjectivesState, initialUIState } from './investment-objectives.state';

export const investmentObjectivesReducer = createReducer(
  initialUIState,
  on(toggleInvestmentObjectivesLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),
  on(loadInvestmentObjectivesSuccess, (state, { investmentObjectives }) => ({
    ...state,
    investmentObjectives,
    loading: false,
  })),
  on(loadInvestmentObjectivesFailure, (state) => ({
    ...state,
    loading: false,
  }))
);